<div class="menu-1" *ngIf="heading">
  <span class="menu-heading">{{ heading }}</span>
  <span class="close" (click)="cancel()">X</span>
</div>
<div class="container">
  <div *ngIf="showSearch == true">
    <app-search-dialog
      (selectedSearchedItem)="handleSelectedUser($event)"
      (notFoundAddNew)="handleSelectedUser($event)" 
      [hideNotFoundButton]="false"
      [isUserSelection]="true"
    ></app-search-dialog>
  </div>
  <div class="row container-fluid" *ngIf = "showAddUser == true">
    <div class="row memberinfo jty-cntr">Add a New User</div>
      <form #userForm="ngForm" (ngSubmit)="confirm(userForm)" novalidate>
        <div class="row centercontent">
           <div class="col-3 dflx"></div>
          <div class="col-3 dflx">
            <div class="dflx-fdirection-column">
              <label class="search-field-label mb-1">First Name</label>
              <input type="text" name="firstName" class="search-field" [(ngModel)]="addMemberData.FirstName" #firstName="ngModel" required minlength="2"> 
              <div *ngIf="firstName.invalid && (submitted || firstName.touched)">
                <small *ngIf="firstName.errors?.['required']" class="star">First Name is required.</small> 
                <small *ngIf="firstName.errors?.['minlength']" class="star">First Name must be at least 2 characters long.</small>
              </div>
            </div>
            
          </div>
          <div class="col-3 d-flex">
             <div class="dflx-fdirection-column">
            <label class="search-field-label mb-1">Last Name</label>
            <input type="text"  name="lastName" class="search-field"  [(ngModel)]="addMemberData.LastName" #lastName="ngModel" required minlength="2">
            <div *ngIf="lastName.invalid && (submitted || lastName.touched)">
              <small *ngIf="lastName.errors?.['required']" class="star">Last Name is required.</small>
              <small *ngIf="lastName.errors?.['minlength']" class="star">Last Name must be at least 2 characters long.</small>
            </div>
          </div>
          </div>
          <div class="col-3 dflx justify-content-end"></div>
        </div>
        <div class="row centercontent">
           <div class="col-3 dflx justify-content-end"></div>
          <div class="col-3 dflx justify-content-end">
            <div class="dflx-fdirection-column">
            <label class="search-field-label mb-1">Email Address</label>
            <input 
              type="email" 
              name="email" 
              class="search-field"  
              [(ngModel)]="addMemberData.Email" 
              #email="ngModel" 
              required 
              pattern="[A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}$"
            >
            <div *ngIf="email.invalid && (submitted || email.touched)">
              <small *ngIf="email.errors?.['required']" class="star">Email is required.</small>
              <small *ngIf="email.errors?.['pattern']" class="star" >Please enter a valid email address.</small>
            </div>
             </div>
          </div> 
          <div class="col-3 d-flex">
              <div class="dflx-fdirection-column">
            <label class="search-field-label mb-1">Telephone</label>
            <input type="text" name="name" class="search-field"  [(ngModel)]="addMemberData.Phone"/>
          </div>
          </div>
        </div>
        <div class="row" style="padding-top: 2rem;">
          <div class="col-6" style="text-align: right;">
            <input class="main-btn ms-2" type="submit" value="Ok" />
          </div>
           <div class="col-6" >
            <input  class="outline-btn ms-2" type="button" value="Cancel" (click)="cancel()" />
          </div>
        </div>
      </form>
  </div>
</div>
